<template>
  <div class="pda-wrap">
    <label class="block-input">
      <p class="block-input_title text-gray pda_title">PD/A</p>
    </label>

    <div class="counterparties-add_block_content" v-for="(item, i) in list" :key="i">
      <label class="block-input" :class="{ 'block-input_error': $v.list.$each[i].cargo.$invalid }">
        <p class="block-input_title text-gray">Cargo #{{i+1}}</p>
        <input class="block-input_content" type="text" v-model.trim="item.cargo">
        <div class="fz10 text-red" v-if="!$v.list.$each[i].cargo.maxLength">The maximum number of characters in the cargo is {{$v.list.$each[i].cargo.$params.maxLength.max}}.</div>
        <div class="fz10 text-red" v-if="!$v.list.$each[i].cargo.required && $v.list.$each[i].cargo.$dirty">One of PD/A fields are required.</div>
      </label>

      <label class="block-input" :class="{ 'block-input_error': $v.list.$each[i].terminal.$invalid }">
        <p class="block-input_title text-gray">Terminal (optional) - Value of PDA (in USD) - Type of vsl (eg bss LME or KMX) </p>
        <input class="block-input_content" type="text" v-model.trim="item.terminal">
        <div class="fz10 text-red" v-if="!$v.list.$each[i].terminal.maxLength">The maximum number of characters in the terminal is {{$v.list.$each[i].terminal.$params.maxLength.max}}.</div>
        <div class="fz10 text-red" v-if="!$v.list.$each[i].terminal.required && $v.list.$each[i].terminal.$dirty">One of PD/A fields are required.</div>
      </label>

      <div class="counterparties-add_block_content__control">
        <button class="counterparties-add_block_content__control_btn" @click="openModal(i)" v-if="list.length > 1">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.6364 4.36585C10.5073 4.36585 10.4091 4.46907 10.4091 4.58852V5.26399H13.5909V4.58852C13.5909 4.46907 13.4927 4.36585 13.3636 4.36585L10.6364 4.36585ZM14.9545 5.26399V4.58852C14.9545 3.70768 14.2387 3 13.3636 3L10.6364 3C9.76125 3 9.04545 3.70768 9.04545 4.58852V5.26399H5.18182C4.80526 5.26399 4.5 5.56975 4.5 5.94692C4.5 6.32409 4.80526 6.62984 5.18182 6.62984H6.31818V16.5059C6.31818 17.8869 7.441 19 8.81818 19H15.1818C16.559 19 17.6818 17.8869 17.6818 16.5059V6.62984H18.8182C19.1947 6.62984 19.5 6.32409 19.5 5.94692C19.5 5.56975 19.1947 5.26399 18.8182 5.26399H14.9545ZM7.68182 6.62984V16.5059C7.68182 17.1255 8.18706 17.6341 8.81818 17.6341H15.1818C15.8129 17.6341 16.3182 17.1255 16.3182 16.5059V6.62984H7.68182ZM10.6364 8.88637C11.0129 8.88637 11.3182 9.19213 11.3182 9.5693V14.5501C11.3182 14.9272 11.0129 15.233 10.6364 15.233C10.2598 15.233 9.95455 14.9272 9.95455 14.5501V9.5693C9.95455 9.19213 10.2598 8.88637 10.6364 8.88637ZM13.3636 8.88637C13.7402 8.88637 14.0455 9.19213 14.0455 9.5693V14.5501C14.0455 14.9272 13.7402 15.233 13.3636 15.233C12.9871 15.233 12.6818 14.9272 12.6818 14.5501V9.5693C12.6818 9.19213 12.9871 8.88637 13.3636 8.88637Z" fill="#094172"/></svg>
          Delete PD/A
        </button>
        <button class="counterparties-add_block_content__control_btn right" @click="addPda" v-if="i == list.length-1 && (item.cargo || item.terminal)">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.3333 11.3333H12.6667V6.66662C12.6667 6.2987 12.368 6 11.9999 6C11.632 6 11.3333 6.2987 11.3333 6.66662V11.3333H6.66662C6.2987 11.3333 6 11.632 6 11.9999C6 12.368 6.2987 12.6667 6.66662 12.6667H11.3333V17.3333C11.3333 17.7013 11.632 18 11.9999 18C12.368 18 12.6667 17.7013 12.6667 17.3333V12.6667H17.3333C17.7013 12.6667 18 12.368 18 11.9999C18 11.632 17.7013 11.3333 17.3333 11.3333Z" fill="#094172"/></svg>
          Add new PD/A
        </button>
      </div>
    </div>
    <del-pda-modal :pdaNumb="delPdaIndex" v-if="ifModalOpen" @submit="deletePda" @close="ifModalOpen = false" />
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { maxLength } from 'vuelidate/lib/validators'

import delPdaModal from '@/components/ports/list/delPdaModal'
import { mapActions } from 'vuex'
export default {
  mixins: [validationMixin],
  components: { delPdaModal },
  props: ['list'],
  data() {
    return {
      ifModalOpen: false,
      delPdaIndex: null,
      /* pda: [
        {
          id: null,
          pda_number: null,
          cargo: '',
          terminal: '',
        },
      ], */
    }
  },
  validations: {
    list: {
      $each: {
        cargo: {
          // required: requiredIf(function (nestedModel) {
          //   if(nestedModel.terminal) {
          //     return false
          //   }else {
          //     return true
          //   }
          // }),
          maxLength: maxLength(200)
        },
        terminal: {
          // required: requiredIf(function (nestedModel) {
          //   if(nestedModel.cargo) {
          //     return false
          //   }else {
          //     return true
          //   }
          // }),
          maxLength: maxLength(500)
        }
      }
    }
  },
  watch: {
    list: function() {this.checkNumb()}
  },
  methods: {
    ...mapActions(['axiosDelPortPda']),
    /* returnPda() {
      if(this.pda[0].cargo || this.pda[0].terminal || this.pda[0].id){
        return this.pda
      }
      return []
    }, */
    addPda() {
      this.list.push({
        id: null,
        pda_number: null,
        cargo: '',
        terminal: '',
      })
    },
    checkNumb() {
      if(this.list.length && typeof this.list[0] == 'number') return false
      
      for (let i = 0; i < this.list.length; i++) {
        const el = this.list[i];
        el.pda_number = i+1
      }
    },
    openModal(i) {
      this.delPdaIndex = i
      this.ifModalOpen = true
    },
    deletePda() {
      if(this.list[this.delPdaIndex].id) {
        this.axiosDelPortPda(this.list[this.delPdaIndex].id)
      }
      this.ifModalOpen = false
      this.list.splice(this.delPdaIndex, 1)
    },
  },
  async mounted() {
    await this.$nextTick()
    if(!this.list.length)
      this.addPda()
  }
}
</script>

<style scoped lang="scss">
  .counterparties-add_block_content__control_btn.right{
    margin-left: auto;
  }
  .pda_title{
    margin-bottom: -6px;
  }
</style>